import React from "react";

import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

import styles from "./warning.module.scss";
import { Button } from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Warning = ({
  showModal,
  title,
  message,
  handleCancelClick,
  handleSubmitClick,
  btn1_title,
  btn2_title,
  btn1_type,
  btn2_type,
  message2,
}) => {
  return (
    <React.Fragment>
      <Dialog
        open={showModal}
        TransitionComponent={Transition}
        onClose={handleCancelClick}
        classes={{
          paper: styles.modalDialog,
        }}
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
      >
        <DialogContent className={styles.modalContent}>
          <div className={`text-center ${styles.modalBody}`}>
            <h5 className={`text-center ${styles.modalTitle}`}>{title}</h5>
            <p className={`${styles.modalMessage}`}>{message}</p>
            <p className={`${styles.modalMessage2}`}>{message2}</p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "40px",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmitClick}
                type={btn1_type ? btn1_type : "submit"}
                className="btn gray-btn d-inline-block mb-3 mr-2"
              >
                {btn1_title ? btn1_title : "Submit"}
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleCancelClick}
                type={btn2_type ? btn2_type : "submit"}
                className="btn gray-btn d-inline-block mb-3 mr-2"
                style={{ color: "whitesmoke", backgroundColor: "#c6c6c6" }}
              >
                {btn1_title ? btn2_title : "Cancel"}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default Warning;
